import { useNavigate, useSearchParams } from 'react-router-dom';
import { RrcCompanyProfileInspector } from '@ots-frontend/ots-ui-tw';
export const RrcCompanyProfileProfilePageRoute = () => {
  const [params] = useSearchParams();
  return (
    <RrcCompanyProfileProfilePage
      id={params.get('id') ?? undefined}
      tenantCode={params.get('tenantCode') ?? undefined}
    />
  );
};
export const RrcCompanyProfileProfilePage = ({
  id,
  tenantCode,
}: {
  id?: string;
  tenantCode?: string;
}) => {
  const navigate = useNavigate();
  return (
    <RrcCompanyProfileInspector
      id={id}
      tenantCode={tenantCode}
      presentation="embedded"
      onClose={() => navigate(-1)}
    />
  );
};
